import { createSlice } from "@reduxjs/toolkit";

export const name = "ui";

const initialState = {
  tables: {
    poppers: {
      currentlyActivePopper: null, // No popper is active initially
    },
  },
};

const uiSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    openPopper(state, action) {
      state.tables.poppers.currentlyActivePopper = action.payload; // Set the active popper key
    },
    closeAllPoppers(state) {
      state.tables.poppers.currentlyActivePopper = null; // Reset to close all poppers
    },
  },
});

export const selectCurrentlyActivePopper = (state) =>
  state[name].tables.poppers.currentlyActivePopper;

export const { openPopper, closeAllPoppers } = uiSlice.actions;
export default uiSlice.reducer;
